<template lang="html">
  <div class="radio-box" @click="change">
		<div class="content" :class="{active: val}"></div>
  </div>
</template>

<script>
export default {
	name: 'radio-box',
	props: ['value'],
	data () {
		return {
			val: false
		}
	},
	mounted () {
		this.val = this.value
	},
	methods: {
		change () {
			this.val = !this.val
			this.$emit('change', this.val)
		}
	}
}
</script>

<style lang="scss" scoped>
$red: #ff4052;
$grey: #d7d7d7;

.radio-box {
	width: 1rem;
	height: 1rem;
	background-color: white;
	border: 1px solid $grey;
	border-radius: 3px;
	position: relative;
	cursor: pointer;

	.content {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		background-color: $red;
		width: 0;
		height: 0;
		border-radius: 2px;
		transition: 0.2s;

		&.active {
			width: 75%;
			height: 75%;
			transition: 0.2s;
		}
	}
}
</style>



// WEBPACK FOOTER //
// RadioBox.vue?3ab2a206